import angular from 'angular';
import '../../common/localizationMapService';

const levelsServices = angular.module('applicationModule.levelsServices', []);

levelsServices.factory('Level', ['LevelAPI', function (LevelAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return LevelAPI.getList(appId, params).then(function (response) {
                return response.data;
            });
        },
        get: function (levelId, appId) {
            return LevelAPI.getLevel(levelId, appId);
        },
        save: function (level, editMode) {
            if (editMode) {
                return LevelAPI.edit(level);
            } else {
                return LevelAPI.create(level);
            }
        },
        remove: function (levelId, appId) {
            return LevelAPI.remove(levelId, appId);
        }
    };
}]);

levelsServices.service('LevelAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/level/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.getLevel = function (levelId, appId) {
        return $http.get(API_URL + levelId, {params: {application_id: appId}});
    };

    this.edit = function (level) {
        return $http.put(API_URL + level.id, level);
    };

    this.create = function (level) {
        return $http.post(API_URL, level);
    };

    this.remove = function (levelId) {
        return $http.delete(API_URL + levelId);
    };
}]);

levelsServices.service('LevelBeaconAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/level-beacons/';

    this.getBeacons = function (levelId) {
        return $http.get(API_URL + levelId);
    };

    this.getList = function (levelId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {level_id: levelId})});
    };

    this.save = function (beacon, editMode) {
        if (editMode) {
            return $http.put(API_URL + 'update/' + beacon.id, beacon);
        } else {
            return $http.post(API_URL + 'create', beacon);
        }
    };

    this.remove = function (beaconId) {
        return $http.delete(API_URL + 'delete/' + beaconId);
    };

    this.getTypes = function () {
        return $http.get(API_URL + 'beacons/types');
    };

    this.deleteBeaconUser = function (userId, beaconId) {
        return $http.delete(API_URL + 'delete/beacon/' + beaconId + '/user/' + userId);
    };

    this.autocomplete = function (appId, search) {
        return $http.get(API_URL + 'beacons/autocomplete/' + appId, {params: {search: search}});
    };
}]);

export default levelsServices;
